<template>
    <div class="row" v-bind:class="{ 'has-danger' : error !== null, 'form-group': !noFormGroup }">
        <label :class="labelClasses" class="form-control-label  col-form-label" :for="name">{{ labelComputed }}</label>
        <div :class="inputHolderClasses">
            <div class="document-editor" :style="editorStyle">
                <div class="document-editor__toolbar" ref="toolbar_container"></div>
                <div class="document-editor__editable-container">
                    <div class="document-editor__editable" :name="name" ref="editor"></div>
                </div>
            </div>
            <span class="help-block form-control-feedback" v-if="error != null"
                    v-text="error"></span>
        </div>
    </div>
</template>

<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document'
    import ElementMixin from '~/mixins/element'
    import UploadAdapter from '~/adapters/CkEditorUploadAdapter'

    export default {
        name: 'BasicCkeditor',
        mixins: [
            ElementMixin,
        ],

        props: {
            inputHolderClasses: {
                type: String,
                required: false,
                default: 'col-md-9 col-xl-10 col-sm-12'
            },
            labelClasses: {
                type: String,
                required: false,
                default: 'col-md-3 col-xl-2 col-sm-12',
            },
            noFormGroup: {
                type: Boolean,
                required: false,
                default: false,
            },
            readonly: {
                type: Boolean,
                required: false,
                default: false,
            },
            value: {
                required: false,
                default: '<p></p>', // Is default value of a new created editor
            },
            editorStyle: {
                type: String,
                required: false,
            }
        },
        watch: {
            value (newVal, oldVal) {
                let html = this.instance.getData();
                if (html !== this.value) {
                    this.instance.setData(this.value);
                }
            },

            readonly(newVal, oldVal) {
                this.instance.isReadOnly = newVal;
            },
        },

        mounted () {
            ClassicEditor
            .create(this.$refs.editor, {
                language: 'nl',
            })
            .then(editor => {
                this.instance = editor;
                editor.setData(this.value);
                editor.isReadOnly = this.readonly;
                this.$refs.toolbar_container.appendChild( editor.ui.view.toolbar.element );

                editor.plugins.get( 'FileRepository' ).createUploadAdapter = loader => {
                    return new UploadAdapter(
                        loader,
                        route('files.store', {'requestUrl': 1 }),
                        editor.t
                    );
                };
                editor.model.document.on('change', () => {
                    this.updateValue(editor.getData());
                });
            })
            .catch(error => {
                console.error(error);
            });
        },

        methods: {
            updateValue: function (value) {
                this.$emit('input', value);
            }
        },
    }
</script>

<style lang="scss">

</style>
